const AWS = require('aws-sdk');

const awsDeleteMailCognito = async (emailData) => {


  AWS.config.update({
    accessKeyId: process.env.VUE_APP_AWS_IAM_USER_KEY,
    secretAccessKey: process.env.VUE_APP_AWS_IAM_USER_SECRET,
    region: 'us-east-1',
  });
  const cognito = new AWS.CognitoIdentityServiceProvider();

  await cognito.adminDeleteUser({
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID,
    Username: emailData.oldEmail,
  }).promise();
};
export { awsDeleteMailCognito as default };
